import React, { useState, useEffect, useRef } from "react";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import {
  editSolicitud,
  createMessage,
  addComentario,
  addDelivery,
} from "../../../slices/thunks";
import { getUrlPrefirmada } from "../../../helpers/backend_helper";
import {
  Col,
  Row,
  Input,
  Label,
  Button,
  Form,
  Card,
  CardBody,
  CardHeader,
  Tooltip,
} from "reactstrap";
import InformacionDelivery from "./InformacionDelivery";
import FileViewer from "../../../Components/Common/FileViewer";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Delivery = ({ usuarios, solicitud, farmacias }) => {
  const dispatch = useDispatch();
  const esMercantil = solicitud?.aseguradora === "Seguros Mercantil";
  const [isLoading, setIsLoading] = useState(true);
  const [responsable, setResponsable] = useState("");
  const [fecha, setFecha] = useState("");
  const [fechaEntrega, setFechaEntrega] = useState("");
  const [hora, setHora] = useState("");
  const [showDelivery, setShowDelivery] = useState(false);
  const [coordenadas, setCoordenadas] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [formErrors, setFormErrors] = useState({
    responsable: false,
    fecha: false,
    hora: false,
  });
  const [loadingx, setLoadingx] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState({});
  const [fileViewerOpen, setFileViewerOpen] = useState(false);
  const [currentFile, setCurrentFile] = useState({
    url: null,
    name: "",
    type: ""
  });
  const processingDeliveryRef = useRef(false); // Bandera para evitar duplicados

  const openImageModal = (imageUrl) => {
    if (!imageUrl) {
      toast.error("No hay comprobante de entrega disponible");
      return;
    }

    if (typeof imageUrl === 'string' && imageUrl.startsWith('http')) {
      // Usar URL prefirmada para archivos en DO Spaces
      getUrlPrefirmada(imageUrl)
        .then(response => {
          if (response.data && response.data.url) {
            setCurrentFile({
              url: response.data.url,
              name: "Comprobante de entrega",
              type: isImageFile(imageUrl) ? "image" : isPdfFile(imageUrl) ? "pdf" : "other"
            });
            setFileViewerOpen(true);
          } else {
            toast.error("No se pudo obtener la URL prefirmada");
          }
        })
        .catch(error => {
          console.error("Error:", error);
          toast.error("Error al obtener la URL prefirmada");
        });
    } else if (typeof imageUrl === 'string' && (isImageFile(imageUrl) || isPdfFile(imageUrl))) {
      // Para contenido base64 u otros formatos
      setCurrentFile({
        url: imageUrl,
        name: "Comprobante de entrega",
        type: isImageFile(imageUrl) ? "image" : "pdf"
      });
      setFileViewerOpen(true);
    } else {
      toast.error("Formato de archivo no válido o URL no disponible");
    }
  };

  // Función para determinar si es una imagen
  const isImageFile = (fileData) => {
    if (!fileData) return false;

    // Si es una URL
    if (fileData.startsWith('http')) {
      const extension = fileData.split('?')[0].toLowerCase();
      return extension.endsWith('.jpg') ||
        extension.endsWith('.jpeg') ||
        extension.endsWith('.png') ||
        extension.endsWith('.gif') ||
        extension.endsWith('.webp') ||
        fileData.includes('/image/');
    }

    // Si es base64
    return fileData.includes("data:image/") ||
      (fileData.includes("base64") && !fileData.includes("JVBERi0"));
  };

  // Función para determinar si es un PDF
  const isPdfFile = (fileData) => {
    if (!fileData) return false;

    // Si es una URL
    if (fileData.startsWith('http')) {
      const extension = fileData.split('?')[0].toLowerCase();
      return extension.endsWith('.pdf') ||
        fileData.includes('/pdf/') ||
        fileData.includes('content-type=application%2Fpdf');
    }

    // Si es base64
    return fileData.includes("data:application/pdf") ||
      fileData.includes("JVBERi0"); // Firma de PDF en base64
  };

  // Función actualizada para abrir imágenes desde URL
  const abrirImagen = (imageUrl) => {
    openImageModal(imageUrl);
  };

  const selectLayoutState = (state) => state;
  const pageData = createSelector(selectLayoutState, (state) => ({
    siscotel: state.Siscotel.siscotel,
    errorFacturacion: state.Siscotel.error,
    loading: state.Siscotel.loading,
    errorMsgFacturacion: state.Siscotel.errorMsg,
    colorMsg: state.Siscotel.colorMsg,
    exito: state.Siscotel.exito,
  }));

  const {
    siscotel,
    errorFacturacion,
    loading,
    errorMsgFacturacion,
    colorMsg,
    exito,
  } = useSelector(pageData);

  useEffect(() => {
    if (solicitud && solicitud.coordenadas) {
      setCoordenadas(true);
    }
    if (solicitud && solicitud.delivery && solicitud.delivery.length > 0) {

      // Tomamos el último delivery registrado (asumiendo que el más reciente está al final)
      const ultimoDelivery = solicitud.delivery[solicitud.delivery.length - 1];
      let fechaAjustada = ultimoDelivery.fecha;

      // Verificar si la fecha termina con 'Z' y eliminarla si está presente
      if (fechaAjustada.endsWith("Z")) {
        fechaAjustada = fechaAjustada.slice(0, -1);
      }

      setFecha(fechaAjustada);

      if (ultimoDelivery.fechaEntrega) {
        fechaAjustada = ultimoDelivery.fechaEntrega;

        if (fechaAjustada.endsWith("Z")) {
          fechaAjustada = fechaAjustada.slice(0, -1);
        }

        setFechaEntrega(fechaAjustada);
      }

      // Solo mostrar el formulario si el último delivery no está entregado Y la solicitud no está entregada
      if (ultimoDelivery.estatus !== "Entregado") {
        setShowDelivery(true);
      }

      if (ultimoDelivery.hora) {
        setHora(ultimoDelivery.hora);
      }
    }


  }, [solicitud]);

  useEffect(() => {
    if (siscotel && siscotel.status == 200 && loadingx && !processingDeliveryRef.current) {
      // Marcar como procesando para evitar duplicados
      processingDeliveryRef.current = true;

      try {
        const fechaEntrega = crearFechaHora(fecha, hora);
        let fechaAjustada = fechaEntrega;

        if (fechaAjustada.endsWith("Z")) {
          fechaAjustada = fechaAjustada.slice(0, -1);
        }

        const now = new Date();
        const creado = new Date(
          now.getTime() - now.getTimezoneOffset() * 60000
        ).toISOString();

        const comentario = {
          tipo: "Enviado",
          mensaje:
            "Datos del Delivery Responsable: " +
            responsable.nombre +
            " " +
            responsable.apellido +
            " Fecha: " +
            formatDate(fechaAjustada),
          estatus: true,
          adjunto: null,
          creado: creado,
        };

        const delivery = {
          servicioEntrega: responsable,
          estatus: "En Transito",
          fecha: fechaEntrega,
        };

        // Función asincrónica para ejecutar las acciones secuencialmente
        const updateSequentially = async () => {
          try {
            // Primero actualizar el delivery
            await dispatch(
              addDelivery({
                identificador: String(solicitud.identificador),
                delivery,
              })
            );

            // Luego actualizar el comentario
            await dispatch(
              addComentario({
                identificador: String(solicitud.identificador),
                comentario,
              })
            );

            toast.success("Delivery registrado exitosamente", {});
          } catch (error) {
            console.error("Error al actualizar:", error);
            toast.error("Error al registrar el delivery");
          } finally {
            setLoadingx(false);
            // Resetear la bandera después de completar
            processingDeliveryRef.current = false;
          }
        };

        // Ejecutar la función asincrónica
        updateSequentially();
      } catch (error) {
        console.error("Error al crear fecha de delivery:", error);
        toast.error(
          `❌ Error en la fecha/hora del delivery: ${error.message}`,
          {
            position: "top-right",
            autoClose: 5000,
          }
        );
        setLoadingx(false);
        // Resetear la bandera en caso de error
        processingDeliveryRef.current = false;
      }
    }
  }, [dispatch, siscotel, loadingx]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // Esto cambia a formato 12 horas con AM/PM
    });
  };

  const formatDate2 = (dateString) => {
    // Verificar el formato de la fecha
    const isZuluTime = dateString.endsWith("Z");
    const date = new Date(dateString);

    // Si es tiempo Zulu, restar 4 horas para convertir a hora de Venezuela
    if (isZuluTime) {
      date.setHours(date.getHours() - 4);
    }

    return new Date(date).toLocaleString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // Función para manejar tooltips
  const toggleTooltip = (id) => {
    setTooltipOpen(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  function crearFechaHora(fecha, hora) {
    // Validar que fecha y hora no estén vacíos
    if (!fecha || !hora) {
      throw new Error("Fecha y hora son requeridos");
    }

    // Asumiendo que fecha está en formato 'YYYY-MM-DD' y hora en formato 'HH:mm'
    const fechaParts = fecha.split("-");
    const horaParts = hora.split(":");

    // Validar formato de fecha
    if (fechaParts.length !== 3) {
      throw new Error("Formato de fecha inválido. Use YYYY-MM-DD");
    }

    // Validar formato de hora
    if (horaParts.length !== 2) {
      throw new Error("Formato de hora inválido. Use HH:mm");
    }

    const [year, month, day] = fechaParts;
    const [hours, minutes] = horaParts;

    // Validar que los valores sean números válidos
    const yearNum = parseInt(year, 10);
    const monthNum = parseInt(month, 10);
    const dayNum = parseInt(day, 10);
    const hoursNum = parseInt(hours, 10);
    const minutesNum = parseInt(minutes, 10);

    if (isNaN(yearNum) || isNaN(monthNum) || isNaN(dayNum) || isNaN(hoursNum) || isNaN(minutesNum)) {
      throw new Error("Fecha u hora contienen valores no numéricos");
    }

    // Validar rangos
    if (monthNum < 1 || monthNum > 12) {
      throw new Error("Mes inválido");
    }
    if (dayNum < 1 || dayNum > 31) {
      throw new Error("Día inválido");
    }
    if (hoursNum < 0 || hoursNum > 23) {
      throw new Error("Hora inválida");
    }
    if (minutesNum < 0 || minutesNum > 59) {
      throw new Error("Minutos inválidos");
    }

    // Crear la fecha en la zona horaria de Venezuela (UTC-4)
    const fechaHoraVenezuela = new Date(
      Date.UTC(yearNum, monthNum - 1, dayNum, hoursNum, minutesNum)
    );

    // Validar que la fecha creada sea válida
    if (isNaN(fechaHoraVenezuela.getTime())) {
      throw new Error("Fecha inválida");
    }

    fechaHoraVenezuela.setHours(fechaHoraVenezuela.getHours()); // Ajustar a UTC-4

    // Formatear la fecha a ISO string
    return fechaHoraVenezuela.toISOString();
  }

  const deliveryUsers =
    usuarios && usuarios[0] && farmacias && farmacias.length > 0
      ? usuarios[0].filter((persona) => {
        // Verificar que el usuario sea Delivery y esté activo
        const isDeliveryAndActive =
          persona.activo === true && persona.perfil === "Delivery";

        // Si el usuario tiene una farmacia asignada, verificar que coincida con el codigoProveedor
        if (isDeliveryAndActive && persona.farmacia) {
          const farmaciaUsuario = farmacias.find(
            (farmacia) => farmacia.id === persona.farmacia
          );

          return (
            farmaciaUsuario &&
            farmaciaUsuario.codigo_myh === solicitud.codigoProveedor
          );
        }

        return false;
      })
      : [];

  function handleResponsale(e) {
    if (usuarios && usuarios[0]) {
      const selectedUser = usuarios[0].find(
        (user) => user.id === e.target.value
      );
      if (selectedUser) {
        setResponsable(selectedUser);
        setFormErrors({ ...formErrors, responsable: false });
      }
    }
  }

  function handleFecha(e) {
    setFecha(e.target.value);
    setFormErrors({ ...formErrors, fecha: false });
  }

  function handleHora(e) {
    setHora(e.target.value);
    setFormErrors({ ...formErrors, hora: false });
  }

  async function handleSubmitDelivery() {
    setLoadingx(true);

    // Validar que la dirección esté verificada
    if (!solicitud.verificacionDireccion?.verificado) {
      toast.error(
        "🔒 No se puede asignar delivery sin confirmar la dirección. " +
        "Por favor, confirme la dirección primero en la sección 'Información para el Delivery'.",
        {
          position: "top-right",
          autoClose: 5000,
        }
      );
      setLoadingx(false);
      return;
    }

    // Validar que la solicitud tenga facturación registrada
    if (!solicitud.porcentaje_avance || solicitud.porcentaje_avance < 40) {
      toast.error(
        "⚠️ No se puede asignar delivery sin facturación registrada. " +
        "Por favor, registre la factura primero.",
        {
          position: "top-right",
          autoClose: 5000,
        }
      );
      setLoadingx(false);
      return;
    }

    // Validar que no haya permiso por monto excedente pendiente
    if (solicitud.facturacion?.some(f => f.permisoExcedente?.pendiente === true)) {
      toast.error(
        "⚠️ No se puede asignar delivery mientras el permiso de Seguros Mercantil por monto excedente esté pendiente. " +
        "Adjunte la captura de aprobación en la sección de Facturación.",
        {
          position: "top-right",
          autoClose: 6000,
        }
      );
      setLoadingx(false);
      return;
    }

    // Objeto para almacenar los estados de error
    const errors = {
      responsable: !responsable,
      fecha: !fecha,
      hora: !hora,
    };

    // Actualizar el estado de los errores
    setFormErrors(errors);

    // Si hay algún error, detener la ejecución
    if (Object.values(errors).some((error) => error)) {
      setShowErrorMessage(true);
      setTimeout(() => setShowErrorMessage(false), 3000); // Ocultar después de 3 segundos
      setLoadingx(false);
      return;
    }

    try {
      const fechaEntrega = crearFechaHora(fecha, hora);
      let fechaAjustada = fechaEntrega;

      if (fechaAjustada.endsWith("Z")) {
        fechaAjustada = fechaAjustada.slice(0, -1);
      }

      // Solo enviar a Siscotel si es MyH+
      if (solicitud.aseguradora === "MyH+") {
        const message = {
          IdentificadorEvento: solicitud.identificador,
          Tipo: "Mensaje",
          Mensaje:
            "Datos del Delivery Responsable: " +
            responsable.nombre +
            " " +
            responsable.apellido +
            " - Fecha: " +
            formatDate(fechaAjustada),
          Adjunto: "",
          CodigoProveedor: solicitud.codigoProveedor,
        };

        await dispatch(createMessage(message));
      }

      // Mover fechaAjustada fuera del try para que esté disponible para el resto del código
      const mensajeDelivery =
        "Datos del Delivery Responsable: " +
        responsable.nombre +
        " " +
        responsable.apellido +
        " - Fecha: " +
        formatDate(fechaAjustada);

      // Para Seguros Mercantil, Latina Salud, Hispana y Real Seguros: guardar comentario localmente y actualizar solicitud
      if (solicitud.aseguradora === "Seguros Mercantil" || solicitud?.aseguradora?.toLowerCase() === "latina salud" || solicitud?.aseguradora?.toLowerCase() === "hispana de seguros" || solicitud?.aseguradora?.toLowerCase() === "real seguros") {
        const comentario = {
          tipo: "Enviado",
          mensaje: mensajeDelivery,
          estatus: true,
          adjunto: null,
          creado: null,
        };
        dispatch(addComentario({ identificador: String(solicitud.identificador), comentario }));

        const delivery = {
          servicioEntrega: responsable,
          estatus: "En Transito",
          fecha: fechaEntrega,
        };
        await dispatch(
          addDelivery({
            identificador: String(solicitud.identificador),
            delivery,
          })
        );



        // Resetear estado de loading para Seguros Mercantil, Latina Salud, Hispana y Real Seguros
        setLoadingx(false);
      } else {
        // Solo enviar a Siscotel si es MyH+
        if (solicitud.aseguradora === "MyH+") {
          const message = {
            IdentificadorEvento: solicitud.identificador,
            Tipo: "Mensaje",
            Mensaje: mensajeDelivery,
            Adjunto: "",
            CodigoProveedor: solicitud.codigoProveedor,
          };
          dispatch(createMessage(message));
        }
      }
    } catch (error) {
      toast.error(
        `Error en MyH+: ${error.message || "Error al procesar delivery"}`,
        {
          position: "top-right",
          autoClose: 5000,
        }
      );
      setLoadingx(false);
    }
  }

  function handleResponsale(e) {
    if (usuarios && usuarios[0]) {
      const selectedUser = usuarios[0].find(
        (user) => user.id === e.target.value
      );
      if (selectedUser) {
        setResponsable(selectedUser);
      }
    }
  }

  function handleFecha(e) {
    setFecha(e.target.value);
  }

  function handleHora(e) {
    setHora(e.target.value);
  }

  const editarSolicitudDelivery = () => {
    setShowDelivery(false);
  };

  /**
   * Renderiza una tabla con la información de delivery de una solicitud.
   * @param {{solicitud: object, onEdit: function}} props
   * @prop {object} solicitud La solicitud que se va a renderizar.
   * @prop {function} onEdit Función que se llama cuando se hace click en la acción de editar.
   * @returns {ReactElement} Un ReactElement que representa la tabla con la información de delivery.
   */
  const DeliveryTable = ({ solicitud, onEdit }) => {
    if (!solicitud || !solicitud.delivery || solicitud.delivery.length === 0) {
      return (
        <div className="text-center p-4 bg-light rounded">
          <i className="ri-information-line fs-24 text-muted mb-2 d-block"></i>
          <p className="mb-0">No hay información de delivery disponible.</p>
        </div>
      );
    }

    return (
      <>
        {solicitud.estatus === "Por Reprogramar" && (
          <div className="text-end col-lg-12 mb-3">
            <Button
              onClick={onEdit}
              className="btn btn-primary btn-sm text-nowrap"
            >
              <i className="ri-user-follow-line me-1" />
              Nuevo Responsable
            </Button>
          </div>
        )}

        <div className="table-responsive">
          <table className="table table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th scope="col" className="fw-semibold">
                  Responsable
                </th>
                <th className="fw-semibold">Teléfono</th>
                <th className="fw-semibold">Estatus</th>
                <th className="fw-semibold">Observación</th>
                <th className="fw-semibold">Por Entregar el</th>
              </tr>
            </thead>
            <tbody>
              {solicitud.delivery.map((delivery, index) => (
                <tr key={index}>
                  <td>
                    <div className="d-flex align-items-center">
                      <div className="avatar-xs me-2 flex-shrink-0">
                        <div className="avatar-title bg-primary-subtle text-primary rounded-circle">
                          {(delivery.servicioEntrega?.nombre?.[0] || "") +
                            (delivery.servicioEntrega?.apellido?.[0] || "")}
                        </div>
                      </div>
                      <div>
                        <span className="fw-medium">
                          {`${delivery.servicioEntrega?.nombre || ""} ${delivery.servicioEntrega?.apellido || ""
                            }`}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td>
                    {delivery.servicioEntrega?.telefono ? (
                      <div className="d-flex align-items-center">
                        <i className="ri-phone-line text-muted me-1"></i>
                        <span>{delivery.servicioEntrega.telefono}</span>
                      </div>
                    ) : (
                      <span className="text-muted">-</span>
                    )}
                  </td>
                  <td>
                    {delivery.estatus ? (
                      <span
                        className={`badge ${getStatusBadgeClass(
                          delivery.estatus
                        )}`}
                      >
                        {delivery.estatus}
                      </span>
                    ) : (
                      <span className="text-muted">-</span>
                    )}
                  </td>
                  <td>
                    {delivery.observacion ? (
                      <span className="text-wrap" style={{ maxWidth: "200px" }}>
                        {delivery.observacion}
                      </span>
                    ) : (
                      <span className="text-muted">-</span>
                    )}
                  </td>
                  <td>
                    {delivery?.fecha ? (
                      <div className="d-flex align-items-center">
                        <i className="ri-calendar-line text-muted me-1"></i>
                        <span>{formatDate2(delivery.fecha)}</span>
                      </div>
                    ) : (
                      <span className="text-muted">No disponible</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  // Función auxiliar para determinar la clase de la insignia según el estado
  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "Pendiente":
        return "bg-warning-subtle text-warning";
      case "En Transito":
        return "bg-info-subtle text-info";
      case "Entregado":
        return "bg-success-subtle text-success";
      case "Cancelado":
        return "bg-danger-subtle text-danger";
      case "Por Reprogramar":
        return "bg-secondary-subtle text-secondary";
      default:
        return "bg-primary-subtle text-primary";
    }
  };

  /**
   * Renderiza una tabla con la información de delivery de una solicitud.
   * @param {{solicitud: object, onEdit: function}} props
   * @prop {object} solicitud La solicitud que se va a renderizar.
   * @prop {function} onEdit Función que se llama cuando se hace click en la acción de editar.
   * @returns {ReactElement} Un ReactElement que representa la tabla con la información de delivery.
   */
  const DeliveryEntregaTable = ({ solicitud }) => {
    // Filtrar solo los deliveries con estatus "Entregado"
    const deliveriesEntregados = solicitud?.delivery?.filter(d => d.estatus === "Entregado") || [];

    if (deliveriesEntregados.length === 0) {
      return (
        <div className="table-responsive">
          <table className="table table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th scope="col" className="fw-semibold">
                  Entregado el
                </th>
                <th className="fw-semibold">Distancia (Km)</th>
                <th className="fw-semibold">Costo Entrega (Bs)</th>
                <th className="fw-semibold">Costo Entrega ($)</th>
                <th className="fw-semibold">Lugar de Entrega</th>
                <th className="fw-semibold">Comprobante</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="6" className="text-center">
                  <div className="p-3">
                    <p className="text-muted mb-0">No hay información de entregas realizadas</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    return (
      <div className="table-responsive">
        <table className="table table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th scope="col" className="fw-semibold">
                Entregado el
              </th>
              <th className="fw-semibold">Distancia (Km)</th>
              <th className="fw-semibold">Costo Entrega (Bs)</th>
              <th className="fw-semibold">Costo Entrega ($)</th>
              <th className="fw-semibold">Lugar de Entrega</th>
              <th className="fw-semibold">Comprobante</th>
            </tr>
          </thead>
          <tbody>
            {deliveriesEntregados.map((delivery, index) => (
              <tr key={`delivery-entregado-${index}`}>
                <td>
                  {delivery.fechaEntrega ? (
                    <span className="text-body-emphasis">
                      {formatDate(delivery.fechaEntrega)}
                    </span>
                  ) : (
                    <span className="text-muted">No disponible</span>
                  )}
                </td>
                <td>
                  {delivery.distancia_real ? (
                    <span className="badge bg-info-subtle text-info fs-12 px-2">
                      {delivery.distancia_real} km
                    </span>
                  ) : (
                    <span className="text-muted">-</span>
                  )}
                </td>
                <td>
                  {delivery.costoEntrega ? (
                    <span className="fw-medium">
                      {delivery.costoEntregaBs}
                    </span>
                  ) : (
                    <span className="text-muted">-</span>
                  )}
                </td>
                <td>
                  {delivery.costoEntrega ? (
                    <span className="fw-medium">
                      {delivery.costoEntrega}
                    </span>
                  ) : (
                    <span className="text-muted">-</span>
                  )}
                </td>

                <td id={`d-date-${index}`}>
                  {delivery.ubicacionEntrega ? (
                    <div>
                      <a
                        href={`https://www.google.com/maps/search/?api=1&query=${delivery.ubicacionEntrega[0]},${delivery.ubicacionEntrega[1]}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm btn-soft-primary"
                      >
                        <i className="ri-map-pin-line me-1"></i>
                        {delivery.ubicacionEntrega[0] !== undefined && delivery.ubicacionEntrega[1] !== undefined ?
                          `${delivery.ubicacionEntrega[0].toFixed(6)}, ${delivery.ubicacionEntrega[1].toFixed(6)}` :
                          'Coordenadas incompletas'}
                      </a>
                    </div>
                  ) : (
                    <span className="text-muted">-</span>
                  )}
                </td>

                <td>
                  {delivery.reciboEntrega ? (
                    <Button
                      color="link"
                      className="p-0 text-info"
                      onClick={(e) => {
                        e.preventDefault();
                        openImageModal(delivery.reciboEntrega);
                      }}
                    >
                      <i
                        className={`me-1 ${typeof delivery.reciboEntrega === 'string' && (
                            delivery.reciboEntrega.toLowerCase().endsWith('.pdf') ||
                            delivery.reciboEntrega.toLowerCase().includes('/pdf/') ||
                            delivery.reciboEntrega.toLowerCase().includes('content-type=application%2Fpdf')
                          )
                            ? "ri-file-pdf-line"
                            : "ri-image-line"
                          }`}
                      ></i>
                      {typeof delivery.reciboEntrega === 'string' && (
                        delivery.reciboEntrega.toLowerCase().endsWith('.pdf') ||
                        delivery.reciboEntrega.toLowerCase().includes('/pdf/') ||
                        delivery.reciboEntrega.toLowerCase().includes('content-type=application%2Fpdf')
                      )
                        ? "Ver PDF"
                        : "Ver Comprobante"}
                    </Button>
                  ) : (
                    <span className="badge bg-danger-subtle text-danger">
                      No disponible
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <React.Fragment>
      <FileViewer
        isOpen={fileViewerOpen}
        toggle={() => setFileViewerOpen(!fileViewerOpen)}
        fileUrl={currentFile.url}
        fileName={currentFile.name}
        fileType={currentFile.type}
      />

      <InformacionDelivery solicitud={solicitud} farmacias={farmacias} />

      {!esMercantil && coordenadas && solicitud && (solicitud.estatus === "Nueva Solicitud" || solicitud.estatus === "Virtual" || solicitud.estatus === "Por Reprogramar") && solicitud.facturacion && solicitud.facturacion.length > 0 ? (
        <Card className="border-0 shadow-sm">
          <CardHeader>
            <div className="d-flex align-items-center">
              <i className="ri-truck-line me-1 text-primary me-2 fs-20"></i>
              <h5 className="card-title mb-0">Información Delivery:</h5>
            </div>
          </CardHeader>

          <CardBody className="p-4">
            <div id="farme__divTabla__delivery"> </div>

            {/* Alerta si la dirección no está verificada */}
            {!solicitud.verificacionDireccion?.verificado && (
              <div
                className="alert alert-danger d-flex align-items-start mb-3"
                role="alert"
              >
                <i className="ri-error-warning-line me-2 fs-18 mt-1"></i>
                <div>
                  <strong>🔒 Dirección no confirmada</strong>
                  <p className="mb-0 mt-1">
                    No se puede asignar delivery sin confirmar la dirección.
                    Por favor, confirme la dirección primero en la sección de "Información para el Delivery".
                  </p>
                </div>
              </div>
            )}

            {/* Alerta si no hay facturación */}
            {(!solicitud.porcentaje_avance || solicitud.porcentaje_avance < 40) && (
              <div
                className="alert alert-warning d-flex align-items-start mb-3"
                role="alert"
              >
                <i className="ri-alert-line me-2 fs-18 mt-1"></i>
                <div>
                  <strong>⚠️ Facturación requerida</strong>
                  <p className="mb-0 mt-1">
                    No se puede asignar delivery sin facturación registrada.
                    Por favor, registre la factura primero en la sección de "Información de Facturación".
                  </p>
                </div>
              </div>
            )}

            {/* Alerta si hay permiso pendiente por monto excedente */}
            {solicitud.facturacion?.some(f => f.permisoExcedente?.pendiente === true) && (
              <div
                className="alert alert-warning d-flex align-items-start mb-3"
                role="alert"
              >
                <i className="ri-mail-send-line me-2 fs-18 mt-1"></i>
                <div>
                  <strong>Permiso de Seguros Mercantil pendiente</strong>
                  <p className="mb-0 mt-1">
                    No se puede asignar delivery mientras el permiso por monto excedente esté pendiente.
                    Adjunte la captura de aprobación en la sección de "Información de Facturación".
                  </p>
                </div>
              </div>
            )}

            {showErrorMessage && (
              <div
                className="alert alert-danger d-flex align-items-center"
                role="alert"
              >
                <i className="ri-error-warning-line me-2 fs-16"></i>
                <div>Por favor complete todos los campos obligatorios</div>
              </div>
            )}

            <Form
              id="delivery-parte1-form"
              className="form-steps"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmitDelivery();
              }}
            >
              <div className="bg-light p-3 rounded mb-4">
                <Row>
                  <Col>
                    <div className="mb-3">
                      <Label
                        className="form-label fw-medium"
                        htmlFor="gen-info-responsable-input"
                      >
                        Responsable <span className="text-danger">*</span>
                      </Label>
                      <select
                        className={`form-select ${formErrors.responsable ? "is-invalid" : ""
                          }`}
                        id="t-status"
                        data-choices
                        data-choices-search-false
                        aria-label="Default select"
                        required
                        disabled={!solicitud.verificacionDireccion?.verificado || !solicitud.porcentaje_avance || solicitud.porcentaje_avance < 40 || solicitud.facturacion?.some(f => f.permisoExcedente?.pendiente === true)}
                        onChange={handleResponsale}
                      >
                        <option value="">Seleccione un responsable</option>
                        {deliveryUsers.map((persona) => (
                          <option key={persona.id} value={persona.id}>
                            {persona.nombre} {persona.apellido}
                          </option>
                        ))}
                      </select>
                      {formErrors.responsable && (
                        <div className="invalid-feedback">
                          Por favor seleccione un responsable
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label
                        className="form-label fw-medium"
                        htmlFor="gen-info-fecha-input"
                      >
                        Fecha para la entrega{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="date"
                        className={`form-control ${formErrors.fecha ? "is-invalid" : ""
                          }`}
                        required
                        disabled={!solicitud.verificacionDireccion?.verificado || !solicitud.porcentaje_avance || solicitud.porcentaje_avance < 40 || solicitud.facturacion?.some(f => f.permisoExcedente?.pendiente === true)}
                        min={new Date().toISOString().split("T")[0]}
                        onChange={(e) => {
                          handleFecha(e);
                          setFormErrors({ ...formErrors, fecha: false });
                        }}
                      />
                      {formErrors.fecha && (
                        <div className="invalid-feedback">
                          Por favor seleccione una fecha
                        </div>
                      )}
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label
                        className="form-label fw-medium"
                        htmlFor="gen-info-hora-input"
                      >
                        Hora de la entrega{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <Input
                        required
                        type="time"
                        className={`form-control ${formErrors.hora ? "is-invalid" : ""
                          }`}
                        id="exampleInputtime"
                        disabled={!solicitud.verificacionDireccion?.verificado || !solicitud.porcentaje_avance || solicitud.porcentaje_avance < 40 || solicitud.facturacion?.some(f => f.permisoExcedente?.pendiente === true)}
                        onChange={(e) => {
                          handleHora(e);
                          setFormErrors({ ...formErrors, hora: false });
                        }}
                      />
                      {formErrors.hora && (
                        <div className="invalid-feedback">
                          Por favor seleccione una hora
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>

              <Row>
                <Col lg={12}>
                  <div className="mb-3 mt-4 text-end">
                    {solicitud.estatus !== "Cancelado" && (
                      <>
                        <Button
                          color="success"
                          className="btn btn-lg px-4"
                          id="registrarDeliveryTooltip"
                          disabled={loadingx || !solicitud.verificacionDireccion?.verificado || !solicitud.porcentaje_avance || solicitud.porcentaje_avance < 40 || solicitud.facturacion?.some(f => f.permisoExcedente?.pendiente === true)}
                          onClick={() => {
                            handleSubmitDelivery();
                          }}
                        >
                          {loadingx ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Registrando...
                            </>
                          ) : (
                            <>
                              <i className="ri-truck-line align-middle fs-16 me-2"></i>
                              Registrar Delivery
                            </>
                          )}
                        </Button>
                        <Tooltip
                          placement="top"
                          isOpen={tooltipOpen.registrarDeliveryTooltip}
                          target="registrarDeliveryTooltip"
                          toggle={() => toggleTooltip('registrarDeliveryTooltip')}
                        >
                          {!solicitud.verificacionDireccion?.verificado
                            ? "Debe confirmar la dirección primero"
                            : !solicitud.porcentaje_avance || solicitud.porcentaje_avance < 40
                              ? "Debe registrar la facturación primero"
                              : solicitud.facturacion?.some(f => f.permisoExcedente?.pendiente === true)
                                ? "Permiso de Seguros Mercantil pendiente por monto excedente"
                                : "Registrar delivery"}
                        </Tooltip>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      ) : null}

      {!esMercantil && showDelivery ? (
        <>
          <Card className="border-0 shadow-sm">
            <CardHeader>
              <div className="d-flex align-items-center">
                <i className="ri-truck-line me-1 text-primary me-2 fs-20"></i>
                <h5 className="card-title mb-0">Información Delivery:</h5>
              </div>
            </CardHeader>

            <CardBody className="p-4">
              <DeliveryTable
                solicitud={solicitud}
                onEdit={editarSolicitudDelivery}
              />
            </CardBody>
          </Card>
        </>
      ) : null}


      <>
        <Card className="border-0 shadow-sm">
          <CardHeader>
            <div className="d-flex align-items-center">
              <i className="ri-check-double-line me-1 text-primary me-2 fs-20"></i>
              <h5 className="card-title mb-0">
                {esMercantil ? "Confirmación de Entrega:" : "Información de la Entrega del Delivery:"}
              </h5>
            </div>
          </CardHeader>

          <CardBody className="p-4">
            <DeliveryEntregaTable solicitud={solicitud} />
          </CardBody>
        </Card>
      </>


    </React.Fragment>
  );
};

export default Delivery;
